(function v1() {
    let $;

    doAfter(() => typeof window.jQuery === 'function', init);

    function init() {
        $ = window.jQuery;

        

        $('.venobox').venobox(); 
        window.AOS.init();
        triggerGalleryPopup();

        $('.dynamic-scratch-slider__inner').slick({
            dots: false,
            infinite: true,
            speed: 500,
            fade: true,
            cssEase: 'linear',
            arrows: false,
            autoplay: true,
            autoplaySpeed: 5000,
            pauseOnHover: false       
        });
        
    }

    function triggerGalleryPopup() {
        const $galleryTriggerLinks = $('a[href*="#gallery-"]');

        if ($galleryTriggerLinks.length > 0) {

            $galleryTriggerLinks.each(function(index) {

                const $galleryLink = $(this);
                const target = $galleryLink.attr('href');
                const $firstImage = $(`${target} a`).first();

                $galleryLink.on('click', function(e){
                    e.preventDefault();
                    $firstImage.click();
                });
            });
        }
    }

}());

function doAfter(condition, success, fail, interval, timeout) {
    const settings = {
        condition: typeof condition === 'function' ? condition : null,
        success: typeof success === 'function' ? success : null,
        fail: typeof fail === 'function' ? fail : null,
        interval: typeof interval === 'number' ? interval : 100,
        timeout: typeof timeout === 'number' ? timeout : 10000
    };

    if (!settings.condition || !settings.success) return false;

    let int = setInterval(() => {
        if (settings.condition()) {
            settings.success();
            clearInterval(int);
            int = null;
        }
    }, settings.interval);

    setTimeout(() => {
        if (int) {
            clearInterval(int);
            if (typeof settings.fail === 'function') {
                settings.fail();
            }
        }
    }, settings.timeout);

    return settings;
}
